import * as React from 'react'
import { adminService } from '../../../../core/services'
import { InputText, ListItem } from '../../../atoms'
import MarkdownEditorWithPreview from '../../../molecules/MarkdownEditorWithPreview'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  path: 'path',
  content: 'content',
}

const title = 'Create page'

const AdminPageNew: React.FC = () => {
  const [content, setContent] = React.useState('')
  const [previewHtml, setPreviewHtml] = React.useState('')

  React.useEffect(() => {
    const timer = setTimeout(async () => {
      try {
        const { html } = await adminService.previewPage(content)
        setPreviewHtml(html)
      } catch (e) {
        // ignore preview errors (e.g. network)
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [content])

  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { flush } = await adminService.createPage(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/admin/pages'
  }, [])

  return (
    <AdminLayoutNew
      model="pages"
      title={title}
      fields={FIELDS}
      indexLink="/admin/pages"
      formItems={
        <>
          <ListItem>
            <InputText required={true} name="path" label="Path" placeholder="terms" />
          </ListItem>
          <ListItem>
            <MarkdownEditorWithPreview
              required={true}
              name="content"
              label="Content (Markdown)"
              placeholder="# Terms of Service"
              value={content}
              previewHtml={previewHtml}
              onChange={setContent}
            />
          </ListItem>
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminPageNew
